import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './MyrbDescription.scss';// to import local scss fle

const MyrbDescription = () => (
  <div className={cn('row', styles.descContainer)}>
    <div className={cn('col s12', styles.descriptionBox)}>
      <div className={cn('col s12', styles.descHeader)}>MyRecruitBoard</div>
      <div className={cn('col s12', styles.descriptionText)}>
        <span className={styles.eyeCaching}>
            The Only Network Built Exclusively on Innovative,
            Scientific, and Data Focused Recruiting
        </span>
        <p>
            Your biometric measurables and academic standings are analyzed
            by our scientific algorithm to maximize your fit
            and exposure to colleges in your state and across the nation.
            90% of our newly upgraded members are contacted by college
            coaches within 48 hours.

        </p>
      </div>
    </div>
    <div className={cn('col s12')}>
      <img className={styles.descImage} alt="Description" src="https://media.dev.myrecruitboard.com/Images/currentFootball.png" />
    </div>
  </div>
);

export default MyrbDescription;



// WEBPACK FOOTER //
// ./src/components/MyrbDescription/MyrbDescription.js